<template>
    <span
        class="badge px-3 py-1 m-0 mt-2"
        :class="getStatusColor()"
        >{{ $tm(statusText) }}</span
    >
</template>
<script lang="ts" setup>
import WellKnown from '@/objects/generated/static/WellKnown';
import { useCommonStoreRef } from '@/stores';
import { computed } from 'vue';

/**
 * This will replace the contestant status id for the correct text from the commonStore
 *
 * Contestant status is typically Registered, Unregistered, Sold etc
 */

const props = defineProps<{
    /**
     * The ID of the contestant status to display
     */
    value: number | null;
}>();

const { ContestantStatus } = useCommonStoreRef();

const statusText = computed(() => {
    if (!props.value) return '';

    const status = ContestantStatus.value.get(props.value);
    return status ? status.text : '';
});

const getStatusColor = () => {
    if (!props.value) {
        return '';
    }

    if (props.value == WellKnown.CONTESTANTSTATUS_SOLDPLACE || props.value == WellKnown.CONTESTANTSTATUS_TRANSFERREDPLACE) {
        return 'bg-warning border border-warning text-dark bg-opacity-50 ';
    } else if (props.value == WellKnown.CONTESTANTSTATUS_CANCELLED) {
        return 'bg-danger text-white border border-danger bg-opacity-50';
    } else if (props.value == WellKnown.CONTESTANTSTATUS_REGISTERED) {
        return 'bg-success text-white border border-success bg-opacity-50';
    } else {
        return 'bg-primary text-white border border-primary bg-opacity-50';
    }
};
</script>
